import React from "react";
import { Button } from "components/common";

const ACHAuthorizationDetailsModal = ({ closeModal }) => {
  const BORDER = { border: "1px solid #e2e8f0" };

  return (
    <div
      style={{ backgroundColor: "#FAFAFA", maxWidth: "600px" }}
      className="py-8 px-12"
    >
      <div className="flex flex-col justify-center items-center">
        <div style={BORDER} className="bg-white">
          I hereby authorize TomoCredit Inc. (“TomoCredit”) to electronically
          debit my bank accounts on a weekly basis (and, if necessary, to
          electronically credit my account to correct erroneous debits) for
          charges on my TomoCredit card as follows: all bank accounts provided
          in my TomoCredit account/dashboard starting with my primary bank
          account and if there are insufficient funds in my primary account,
          TomoCredit may then debit the secondary account and other accounts
          that I have provided to Tomocredit; Tomocredit may debit the other
          accounts that I provided, if the secondary account has insufficient
          funds. I agree that ACH transactions I authorize comply with all
          applicable law. I understand that this authorization will remain in
          full force and effect until I notify TomoCredit by emailing
          help@tomocredit.com to revoke this authorization. I understand that
          TomoCredit requires at least 4 days (business days) written notice.
          <br />
          <br />
          Opt out of Autopay- You can opt out of Autopay by contacting
          TomoCredit at help@tomocredit.com
        </div>

        <Button
          className="mb-6 mt-5 w-36 text-2xl btn-green"
          onClick={() => closeModal()}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

export default ACHAuthorizationDetailsModal;
